
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class BrandMasterDialog extends Serenity.EntityDialog<BrandMasterRow, any> {
        protected getFormKey() { return BrandMasterForm.formKey; }
        protected getIdProperty() { return BrandMasterRow.idProperty; }
        protected getLocalTextPrefix() { return BrandMasterRow.localTextPrefix; }
        protected getNameProperty() { return BrandMasterRow.nameProperty; }
        protected getService() { return BrandMasterService.baseUrl; }
        protected getInsertPermission() { return BrandMasterRow.insertPermission; }
        protected getUpdatePermission() { return BrandMasterRow.updatePermission; }
        protected getDeletePermission() { return BrandMasterRow.deletePermission; }




        protected useViewMode() { return true; }

        protected form = new BrandMasterForm(this.idPrefix);

        constructor() {
            super();
            this.form.BrandCode.changeSelect2(e => {
                var id = AttributeMasterRow.getLookup().items.filter(x => x.AttributeCode.toUpperCase() == this.form.BrandCode.value.toUpperCase())[0];
                if (id != undefined) {
                    if (id.AttributeId != null || id.AttributeId > 0) {
                        Q.notifyError("Duplicate Brand " + this.form.BrandCode.value);
                        this.form.BrandCode.value = "";
                        return;
                    }
                }
                else {
                    this.form.BrandCode.value = this.form.BrandCode.value.toUpperCase();
                }
            })
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            
            return btns;
        }
        private 
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            var id = BrandMasterRow.getLookup().items.filter(x => x.BrandName == this.form.BrandName.value)[0];
            //var refid = CommonAttributesRow.getLookup().items.filter(x => x.BrandId == id.BrandId)[0];
            var refid: Common.CommonAttributeResponse;
            OMS.CommonAttributesService.GetProductATB({
                BrandId: id.BrandId
            }, response => {
                refid = response;
            }, { async: false });
            if (refid != null) {
                if (refid.AttributeId != null || refid.AttributeId > 0) {
                    Q.alert("Brand is in use, Cannot delete");
                    return;
                }
            } else {
               BrandMasterService.Delete(
                   {
                        
                        EntityId: this.entityId
                    }, response => {
                    Serenity.SubDialogHelper.triggerDataChange(self);
                    self.dialogClose();
                    window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                });
            }

        }
    }
}